import { EuiLink, EuiText } from "@inscopix/ideas-eui";
import { ButtonViewTaskLogs } from "components/ButtonViewTaskLogs/ButtonViewTaskLogs";
import { Project, Task } from "graphql/_Types";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import moment from "moment";
import { flyoutDrsFileInfoStyles } from "./FlyoutDrsFileInfoBase";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { UserAvatarRenderer } from "components/UserAvatarRenderer/UserAvatarRenderer";
import { ShortTaskId } from "components/ShortTaskId/ShortTaskId";

export interface DrsFileInfoAnalysisTableProps {
  task: Pick<Task, "id" | "created" | "status" | "userId">;
  project: Pick<Project, "key">;
  analysisTable: { id: string; name: string | null; key: string };
}

export const DrsFileInfoAnalysisTable = ({
  task,
  project,
  analysisTable,
}: DrsFileInfoAnalysisTableProps) => {
  const routeMap = useRouteMapContext((s) => s.routeMap);
  const currentTenant = useTenantContext((s) => s.currentTenant);

  return (
    <EuiText size="s" css={flyoutDrsFileInfoStyles.descriptionListStyles}>
      <dl>
        <dt>Generated:</dt>
        <dd>{moment(task.created).format("MMMM Do YYYY, h:mm:ss a")}</dd>
        <dt>Source:</dt>
        <dd>
          <EuiLink
            to={
              routeMap["PROJECT_TABLE"].dynamicPath({
                tenantKey: currentTenant.key,
                projectKey: project.key,
                tableKey: analysisTable.key,
              }).path
            }
            data-test-subj="analysisTableLink"
          >
            {analysisTable.name}
          </EuiLink>
        </dd>
        <dt>Task ID:</dt>
        <dd>
          <ShortTaskId taskId={task.id} />
        </dd>
        <dt>User:</dt>
        <dd>
          <UserAvatarRenderer
            userId={task.userId}
            displayName={true}
            size="s"
          />
        </dd>
        <dt>Log:</dt>
        <dd>
          <ButtonViewTaskLogs
            taskId={task.id}
            taskStatus={task.status}
            taskCreated={task.created}
          />
        </dd>
      </dl>
    </EuiText>
  );
};
